import { isEmpty } from "lodash-es"

export const isMobile = (val) => {
  const _val = restoreMobile(String(val))
  return isEmpty(val) || (_val.length >= 10 && _val.length <= 13)
}

export const transformMobile = (val) => {
  if (!val) return val
  const _val = restoreMobile(val).slice(0, 12)
  return _val.replace(/[^0-9]/g, "").replace(/(^02|^0505|^0507|^1[0-9]{3}|^0[0-9]{2})([0-9]+)?([0-9]{4})$/, "$1-$2-$3").replace("--", "-")
}

export const restoreMobile = (val) => {
  if (!val) return val
  return val.replace(/[^0-9]/g, "").replace(/[-]/g, "")
}

export const isMobileWithAsterisk = (val) => {
  const _val = restoreMobileWithAsterisk(String(val))
  return isEmpty(val) || (_val.length >= 9 && _val.length <= 13)
}


export const transformMobileWithAsterisk = (val) => {
  if (!val) return val
  const _val = restoreMobileWithAsterisk(val).slice(0, 12)
  return _val.replace(/[^0-9*]/g, "").replace(/(^02|^0505|^0507|^1[0-9*]{3}|^0[0-9*]{2})([0-9*]+)?([0-9*]{4})$/, "$1-$2-$3").replace("--", "-")
}

export const restoreMobileWithAsterisk = (val) => {
  if (!val) return val
  return val.replace(/[^0-9*]/g, "").replace(/[-]/g, "")
}